import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import MobileStepper from 'material-ui/MobileStepper';
import Button from 'material-ui/Button';
import KeyboardArrowLeft from 'material-ui-icons/KeyboardArrowLeft';
import KeyboardArrowRight from 'material-ui-icons/KeyboardArrowRight';

class ProgressMobileStepper extends React.Component {
    state = {
        activeStep: 0,
    };

    handleNext = () => {
        this.setState({
            activeStep: this.state.activeStep + 1,
        });
    };

    handleBack = () => {
        this.setState({
            activeStep: this.state.activeStep - 1,
        });
    };

    render() {
        const {theme} = this.props;

        return (
            <MobileStepper
                type="progress"
                steps={6}
                position="static"
                activeStep={this.state.activeStep}
                style={{
                    maxWidth: 400,
                    flexGrow: 1,
                }}
                nextButton={
                    <Button dense onClick={this.handleNext} disabled={this.state.activeStep === 5}>
                        Next
                        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                    </Button>
                }
                backButton={
                    <Button dense onClick={this.handleBack} disabled={this.state.activeStep === 0}>
                        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                        Back
                    </Button>
                }
            />
        );
    }
}

ProgressMobileStepper.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(null, {withTheme: true})(ProgressMobileStepper);


// WEBPACK FOOTER //
// ./app/routes/components/routes/stepper/progress/ProgressMobileStepper.js